import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import {
  AgentChatWorkspaceExhibit,
  ExhibitLabelFormat,
} from '@/services/types/agent-chat-workspace-types';

import { ExhibitItem } from './ExhibitItem';

interface ExhibitsListProps {
  exhibits: AgentChatWorkspaceExhibit[];
  labelFormat?: ExhibitLabelFormat;
  onUpdateName: (exhibitId: string, newName: string) => void;
  onReorder: (fromIndex: number, toIndex: number) => void;
  onDelete: (exhibitId: string) => void;
}

export const ExhibitsList = ({
  exhibits,
  labelFormat,
  onUpdateName,
  onReorder,
  onDelete,
}: ExhibitsListProps) => {
  if (exhibits.length === 0) {
    return (
      <div className="flex h-32 items-center justify-center text-gray-500">
        <div className="text-center">
          <p className="text-sm font-medium">No exhibits yet</p>
          <p className="text-xs">
            Click &quot;Add Exhibit&quot; to get started
          </p>
        </div>
      </div>
    );
  }

  const exhibitIds = exhibits.map((exhibit) => exhibit.id);

  return (
    <SortableContext items={exhibitIds} strategy={verticalListSortingStrategy}>
      <div className="divide-y divide-gray-100">
        {exhibits.map((exhibit, index) => (
          <ExhibitItem
            key={exhibit.id}
            exhibit={exhibit}
            index={index}
            labelFormat={labelFormat}
            onUpdateName={onUpdateName}
            onMoveUp={index > 0 ? () => onReorder(index, index - 1) : undefined}
            onMoveDown={
              index < exhibits.length - 1
                ? () => onReorder(index, index + 1)
                : undefined
            }
            onDelete={onDelete}
          />
        ))}
      </div>
    </SortableContext>
  );
};
